/* Vanshitaaz — collection-2026 cards.
   ADD TO BAG opens a shared bottom-sheet, populated from the clicked card.
   Pick a size (or Top + Bottom) -> tap-to-add via the theme's addToCartQuick.
   SIZE GUIDE builds the same chart the product page uses (custom.size_chart_json).
   Event-delegated so it survives filter/pagination re-renders. */
(function () {
  'use strict';

  var sheet, groupsEl, phImg, phTitle, phPrice, phModel, hintEl, sg, sgTitle, sgBody;
  var fabricEl, galleryEl, mediaRow, dotsEl, addCartBtn, scrollHint, panel;
  var selectedVariant = null;
  var activeCard = null;
  var galleryUrls = [];        // media URLs of the open card, in slide order
  var galleryLoop = false;     // whether clone slides bracket the real ones

  function el(id) { return document.getElementById(id); }

  function init() {
    sheet = el('c26-sheet');
    if (!sheet) return;
    groupsEl = sheet.querySelector('[data-c26-groups]');
    phImg = sheet.querySelector('[data-c26-ph-img]');
    phTitle = sheet.querySelector('[data-c26-ph-title]');
    phPrice = sheet.querySelector('[data-c26-ph-price]');
    phModel = sheet.querySelector('[data-c26-ph-model]');
    hintEl = sheet.querySelector('[data-c26-hint]');
    fabricEl = sheet.querySelector('[data-c26-ph-fabric]');
    galleryEl = sheet.querySelector('[data-c26-gallery]');
    mediaRow = sheet.querySelector('[data-c26-media-row]');
    dotsEl = sheet.querySelector('[data-c26-dots]');
    addCartBtn = sheet.querySelector('[data-c26-addcart]');
    scrollHint = sheet.querySelector('[data-c26-scrollhint]');
    panel = sheet.querySelector('.c26-sheet__panel');
    if (panel) {
      panel.addEventListener('scroll', function () {
        if (scrollHint && panel.scrollTop > 8) scrollHint.classList.add('is-hidden');
      }, { passive: true });
    }
    if (scrollHint) {
      scrollHint.addEventListener('click', function () {
        if (panel) panel.scrollTo({ top: panel.scrollHeight, behavior: 'smooth' });
      });
    }
    sg = el('c26-sizeguide');
    sgTitle = sg ? sg.querySelector('[data-c26-sg-title]') : null;
    sgBody = sg ? sg.querySelector('[data-c26-sg-body]') : null;
  }

  function openSheet(card) {
    activeCard = card;
    phImg.src = card.getAttribute('data-img') || '';
    phTitle.textContent = card.getAttribute('data-title') || '';
    phTitle.setAttribute('href', card.getAttribute('data-url') || '#');
    phPrice.textContent = card.getAttribute('data-price') || '';
    phModel.textContent = card.getAttribute('data-model') || '';
    hintEl.textContent = '';

    // fabric (custom.material_2)
    if (fabricEl) {
      var fab = card.getAttribute('data-fabric') || '';
      fabricEl.textContent = fab;
      fabricEl.style.display = fab ? '' : 'none';
    }

    // quick-view gallery (approach A): build only when the card carries media
    buildGallery(card);

    var tmpl = card.querySelector('[data-c26-opts]');
    groupsEl.innerHTML = '';
    if (tmpl) { groupsEl.appendChild(tmpl.content.cloneNode(true)); }
    syncAddButton();
    if (panel) panel.scrollTop = 0;

    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('c26-noscroll');
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!sg || !sg.classList.contains('is-open')) { document.body.classList.remove('c26-noscroll'); }
    activeCard = null;
  }

  function makeSlide(url, eager) {
    var s = document.createElement('div');
    s.className = 'c26-sheet__slide';
    var img = document.createElement('img');
    img.loading = eager ? 'eager' : 'lazy';
    if (eager) { img.fetchPriority = 'high'; }
    img.decoding = 'async';
    img.alt = '';
    img.src = url;
    s.appendChild(img);
    return s;
  }

  // Build the swipe gallery (lazy images, load on open) with seamless infinite
  // loop: clone last->front and first->end, then jump between the identical
  // clone/real slide once the scroll settles.
  function buildGallery(card) {
    if (!galleryEl) return;
    var urls = [];
    var script = card.querySelector('[data-c26-media]');
    if (script) { try { urls = JSON.parse(script.textContent); } catch (e) { urls = []; } }

    if (!urls.length) {
      galleryUrls = [];
      galleryEl.setAttribute('hidden', '');
      if (phImg) phImg.style.display = '';   // fall back to the small thumbnail
      if (scrollHint) scrollHint.hidden = true;
      return;
    }

    if (phImg) phImg.style.display = 'none';
    if (scrollHint) { scrollHint.hidden = false; scrollHint.classList.remove('is-hidden'); }
    mediaRow.innerHTML = '';
    dotsEl.innerHTML = '';

    var n = urls.length;
    var loop = n > 1;
    galleryUrls = urls;
    galleryLoop = loop;

    // reuse the card's already-loaded image for the first slide -> instant, no network
    var cardImg = card.querySelector('.c26-card__media img');
    var firstSrc = (cardImg && (cardImg.currentSrc || cardImg.src)) || urls[0];

    if (loop) { mediaRow.appendChild(makeSlide(urls[n - 1], false)); }
    urls.forEach(function (u, i) { mediaRow.appendChild(makeSlide(i === 0 ? firstSrc : u, i === 0)); });
    if (loop) { mediaRow.appendChild(makeSlide(urls[0], false)); }

    urls.forEach(function (u, i) {
      var dot = document.createElement('span');
      dot.className = 'c26-sheet__dot' + (i === 0 ? ' is-active' : '');
      dotsEl.appendChild(dot);
    });
    galleryEl.removeAttribute('hidden');

    function w() { return mediaRow.clientWidth || 1; }
    function setDots(real) {
      var dd = dotsEl.children;
      for (var d = 0; d < dd.length; d++) { dd[d].classList.toggle('is-active', d === real); }
    }

    // start on the first real slide
    requestAnimationFrame(function () { mediaRow.scrollLeft = loop ? w() : 0; });

    var settle;
    mediaRow.onscroll = function () {
      var raw = Math.round(mediaRow.scrollLeft / w());
      var real = loop ? (((raw - 1) % n) + n) % n : raw;
      setDots(real);
      if (!loop) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        var r = Math.round(mediaRow.scrollLeft / w());
        if (r === 0) { mediaRow.scrollLeft = n * w(); }        // front clone -> real last
        else if (r === n + 1) { mediaRow.scrollLeft = w(); }   // end clone -> real first
      }, 90);
    };
  }

  // Colour swatch -> swipe the gallery to that colour's image. The variant JSON
  // carries the same width-600 URL that data-c26-media lists, so the slide is
  // found by index rather than by rebuilding the gallery.
  function showSwatchMedia(valBtn) {
    if (!activeCard || !mediaRow || !galleryUrls.length) return;
    var optIdx = parseInt(valBtn.getAttribute('data-opt-index'), 10);
    var value = valBtn.getAttribute('data-value');
    if (isNaN(optIdx) || !value || value === '__default') return;

    var script = activeCard.querySelector('[data-c26-variants]');
    if (!script) return;
    var data;
    try { data = JSON.parse(script.textContent); } catch (e) { return; }

    var img = '';
    for (var i = 0; i < data.length; i++) {
      if (data[i].options[optIdx] === value && data[i].image) { img = data[i].image; break; }
    }
    if (!img) return;

    var idx = galleryUrls.indexOf(img);
    if (idx < 0) return;
    var w = mediaRow.clientWidth || 1;
    var left = (galleryLoop ? idx + 1 : idx) * w;
    if (mediaRow.scrollTo) { mediaRow.scrollTo({ left: left, behavior: 'smooth' }); }
    else { mediaRow.scrollLeft = left; }
  }

  // Reflect the current selection on the Add to cart button.
  function syncAddButton() {
    if (!addCartBtn) return;
    var res = resolveVariant();
    if (!res.complete) { selectedVariant = null; addCartBtn.disabled = true; addCartBtn.textContent = 'Select a size'; return; }
    if (res.id && res.available) { selectedVariant = res.id; addCartBtn.disabled = false; addCartBtn.textContent = 'Add to cart'; }
    else { selectedVariant = null; addCartBtn.disabled = true; addCartBtn.textContent = 'Sold out'; }
  }

  // Resolve variant id from the chosen values (single or multi-option)
  function resolveVariant() {
    var groups = groupsEl.querySelectorAll('.c26-sheet__group');
    var chosen = [];
    var complete = true;
    var directId = '';
    groups.forEach(function (g) {
      var sel = g.querySelector('.c26-sheet__val.is-sel');
      if (sel) {
        chosen.push(sel.getAttribute('data-value'));
        if (sel.getAttribute('data-value') === '__default') { directId = sel.getAttribute('data-variant-id') || ''; }
      } else { complete = false; }
    });
    if (!complete) { return { complete: false }; }
    if (directId) { return { complete: true, id: directId, available: true }; }

    var data = [];
    var script = activeCard.querySelector('[data-c26-variants]');
    try { data = JSON.parse(script.textContent); } catch (e) { data = []; }
    var match = data.filter(function (v) {
      return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];
    if (match) { return { complete: true, id: String(match.id), available: match.available }; }
    return { complete: true, id: '', available: false };
  }

  function addToBag(variantId) {
    hintEl.textContent = '';
    // "Move to Bag" from the wishlist drawer — once it's in the cart it's no
    // longer a wishlist item. VZWishlist.remove() also updates the header
    // bubble; the drawer listens for the same event to drop the card's DOM node.
    var wishlistCard = activeCard && activeCard.hasAttribute('data-wishlist-item') ? activeCard : null;
    if (wishlistCard && window.VZWishlist) {
      window.VZWishlist.remove(wishlistCard.getAttribute('data-product-id'));
    }
    if (typeof window.addToCartQuick === 'function') {
      try { window.addToCartQuick(variantId, 1); } catch (e) { /* no-op */ }
      closeSheet();
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.status) { throw new Error(d.description || 'Could not add'); }
          window.location.reload();
        })
        .catch(function () { hintEl.textContent = 'Could not add — please try again.'; });
    }
  }

  // ---- Size guide: build the same table the product page renders ----
  function cap(s) { return String(s).charAt(0).toUpperCase() + String(s).slice(1); }

  function buildSizeGuide() {
    if (!sg || !activeCard) return;
    sgTitle.textContent = activeCard.getAttribute('data-title') || 'Size Charts';
    var script = activeCard.querySelector('[data-c26-chart]');
    if (!script) {
      sgBody.innerHTML = '<p style="text-align:center;">No size chart is available for this product.</p>';
    } else {
      var charts;
      try { charts = JSON.parse(script.textContent); } catch (e) { charts = null; }
      sgBody.innerHTML = charts ? renderCharts(charts) : '<p style="text-align:center;">No size chart is available for this product.</p>';
    }
    sg.classList.add('is-open');
    document.body.classList.add('c26-noscroll');
  }

  // Normalize to [key, value] pairs whether the source is an object or an array.
  function entries(x) {
    if (Array.isArray(x)) { return x; }
    if (x && typeof x === 'object') { return Object.keys(x).map(function (k) { return [k, x[k]]; }); }
    return [];
  }

  // charts mirrors custom.size_chart_json (same source as size-chart-popup.liquid),
  // typically nested objects: { type: { size: { measurement: value } } }
  function renderCharts(charts) {
    var html = '';
    entries(charts).forEach(function (chart) {
      var typeName = chart[0];
      var rows = entries(chart[1]);
      if (!rows.length) return;
      var measurements = entries(rows[0][1]).map(function (m) { return m[0]; });
      html += '<h4 class="c26-sg__type">' + cap(typeName) + ' (in Inches)</h4>';
      html += '<div style="overflow-x:auto;-webkit-overflow-scrolling:touch;"><table><thead><tr><th>Size</th>';
      measurements.forEach(function (m) { html += '<th>' + cap(String(m).replace(/_/g, ' ')) + '</th>'; });
      html += '</tr></thead><tbody>';
      rows.forEach(function (row) {
        html += '<tr><td>' + row[0] + '</td>';
        entries(row[1]).forEach(function (m) { html += '<td>' + m[1] + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table></div>';
    });
    return html || '<p style="text-align:center;">No size chart is available for this product.</p>';
  }

  function closeSizeGuide() {
    if (!sg) return;
    sg.classList.remove('is-open');
    if (!sheet.classList.contains('is-open')) { document.body.classList.remove('c26-noscroll'); }
  }

  document.addEventListener('click', function (e) {
    if (!sheet) init();
    if (!sheet) return;

    // colourway dot -> swap the card image + point the card at that variant
    var swBtn = e.target.closest('[data-c26-swatch]');
    if (swBtn) {
      e.preventDefault();
      var swCard = swBtn.closest('[data-c26-card]');
      if (swCard) {
        var cardImg = swCard.querySelector('.c26-card__media img');
        var newSrc = swBtn.getAttribute('data-img');
        if (cardImg && newSrc) {
          cardImg.removeAttribute('srcset');   // srcset would win over the new src
          cardImg.src = newSrc;
        }
        var vid = swBtn.getAttribute('data-variant');
        var baseUrl = swCard.getAttribute('data-url');
        if (vid && baseUrl) {
          swCard.querySelectorAll('a.c26-card__media, a.c26-card__title').forEach(function (a) {
            a.href = baseUrl + '?variant=' + vid;
          });
        }
        swCard.querySelectorAll('[data-c26-swatch]').forEach(function (b) { b.classList.remove('is-sel'); });
        swBtn.classList.add('is-sel');
      }
      return;
    }

    // open
    var openBtn = e.target.closest('[data-c26-open]');
    if (openBtn) { var c = openBtn.closest('[data-c26-card]'); if (c) openSheet(c); return; }

    // close sheet
    if (e.target.closest('[data-c26-close]')) { closeSheet(); return; }

    // size guide open / close
    if (e.target.closest('[data-c26-guide]')) { buildSizeGuide(); return; }
    if (e.target.closest('[data-c26-sg-close]') || e.target === sg) { closeSizeGuide(); return; }

    // size selection -> just select + update the Add to cart button (no auto-add)
    var valBtn = e.target.closest('[data-c26-val]');
    if (valBtn && !valBtn.classList.contains('oos') && !valBtn.disabled) {
      var group = valBtn.closest('.c26-sheet__group');
      group.querySelectorAll('.c26-sheet__val').forEach(function (b) { b.classList.remove('is-sel'); });
      valBtn.classList.add('is-sel');
      // swatch balls show no text, so echo the chosen colour beside the label
      var gsel = group.querySelector('[data-c26-gsel]');
      if (gsel) { gsel.textContent = valBtn.getAttribute('title') || ''; }
      if (valBtn.classList.contains('c26-sheet__val--sw')) { showSwatchMedia(valBtn); }
      hintEl.textContent = '';
      syncAddButton();
      return;
    }

    // Add to cart button
    var addBtn = e.target.closest('[data-c26-addcart]');
    if (addBtn && !addBtn.disabled && selectedVariant) {
      addToBag(selectedVariant);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sg && sg.classList.contains('is-open')) { closeSizeGuide(); }
    else if (sheet && sheet.classList.contains('is-open')) { closeSheet(); }
  });

  // Featured-collection Quick View: move each button to sit right under the
  // card media (like the collection-2026 card add strip).
  function placeFcButtons() {
    document.querySelectorAll('.c26-fc-item').forEach(function (item) {
      var btn = item.querySelector(':scope > .c26-fc-qv');
      if (!btn) return;
      var media = item.querySelector('.card__inner') || item.querySelector('.card__media');
      if (media && media.parentNode) { media.parentNode.insertBefore(btn, media.nextSibling); }
    });
  }

  function boot() { init(); placeFcButtons(); }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
